import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Fix for background pattern not showing on route changes
    const root = document.getElementById('root');
    if (root) {
      // We'll use a more reliable approach - apply Pattern1.png directly
      // This ensures it's always applied, even if computedStyle has issues
      const patternUrl = `url(${window.location.origin}/Pattern1.png)`;
      
      // No need to set to 'none' first - just reapply the background
      root.style.backgroundImage = patternUrl;
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;
